/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2539
 */

var r = require(/* 2540 */"./2540/index")
module.exports = function (e) {
  return r(e, 5)
}
